
import { Component } from 'vue-property-decorator';
import Page from '@/Page.vue';
import ApiService from '@/libs/core/api-service';

@Component({})
export default class AdminActions extends Page {
    running = false;
    runningUpcoming = false;
    showToast = false;
    toastTitle: string | null = null;
    toastText: string | null = null;
    toastCss: string | undefined = undefined;

    async runAlerts() {
        if (this.running) return;
        this.running = true;
        this.showToast = false;

        try {
            const res = await ApiService.api.runNotificationAlerts();
            const ok = (res as any)?.ok ?? false;
            if (ok) {
                this.toastTitle = this.$t('admin.actions.result.okTitle') as any;
                this.toastText = this.$t('admin.actions.result.okText') as any;
                this.toastCss = 'success';
            } else {
                this.toastTitle = this.$t('admin.actions.result.errorTitle') as any;
                this.toastText = this.$t('admin.actions.result.errorText') as any;
                this.toastCss = 'error';
            }
        } catch (e) {
            this.toastTitle = this.$t('admin.actions.result.errorTitle') as any;
            this.toastText = this.$t('admin.actions.result.errorText') as any;
            this.toastCss = 'error';
        } finally {
            this.showToast = true;
            this.running = false;
        }
    }

    async runUpcoming() {
        if (this.runningUpcoming) return;
        this.runningUpcoming = true;
        this.showToast = false;

        try {
            const res = await ApiService.api.runUpcomingAlerts();
            const ok = (res as any)?.ok ?? false;
            if (ok) {
                this.toastTitle = this.$t('admin.actions.result.okTitle') as any;
                this.toastText = this.$t('admin.actions.result.okText') as any;
                this.toastCss = 'success';
            } else {
                this.toastTitle = this.$t('admin.actions.result.errorTitle') as any;
                this.toastText = this.$t('admin.actions.result.errorText') as any;
                this.toastCss = 'error';
            }
        } catch (e) {
            this.toastTitle = this.$t('admin.actions.result.errorTitle') as any;
            this.toastText = this.$t('admin.actions.result.errorText') as any;
            this.toastCss = 'error';
        } finally {
            this.showToast = true;
            this.runningUpcoming = false;
        }
    }
}
